<template>
  <v-row justify="space-around">
    <v-col cols="auto">
      <v-dialog
        v-bind="$attrs"
      >
     <v-card-text>
       <slot/>
     </v-card-text>
        <template v-slot:activator="dialog">
          <v-card>
            <v-toolbar height="40" color="primary" dark>{{title}}</v-toolbar>
            <v-card-text>
              <slot
                slot="content"
                name="content"
              />
            </v-card-text>
            <!-- <v-card-actions class="justify-end">
              <slot
                slot="actions"
                name="actions"
              />
            </v-card-actions> -->
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'MaterialDailog',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>
